import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CACHE_PREFIX = 'khajuraho_trans_';

const getCacheKey = (text, lang) => `${CACHE_PREFIX}${lang}_${text}`;

const getCached = (text, lang) => {
  try {
    const cached = localStorage.getItem(getCacheKey(text, lang));
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
};

const setCache = (text, lang, translation) => {
  try {
    localStorage.setItem(getCacheKey(text, lang), JSON.stringify(translation));
  } catch {
    /* localStorage full */
  }
};

const translateApi = async (text, target) => {
  const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=${target}&dt=t&q=${encodeURIComponent(text)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Translation failed');
  const data = await res.json();
  return data[0].map(s => s[0]).join('');
};

const TranslateText = ({ text, fallback }) => {
  const { i18n } = useTranslation();
  const [translated, setTranslated] = useState(null);
  const lang = i18n.language;

  useEffect(() => {
    if (!text || lang === 'en') {
      setTranslated(null);
      return;
    }

    const cached = getCached(text, lang);
    if (cached) {
      setTranslated(cached);
      return;
    }

    let cancelled = false;
    translateApi(text, lang).then(result => {
      if (!cancelled) {
        setCache(text, lang, result);
        setTranslated(result);
      }
    }).catch(() => {
      if (!cancelled) setTranslated(null);
    });

    return () => { cancelled = true; };
  }, [text, lang]);

  if (lang === 'en') return text;
  return translated || fallback || text;
};

export default TranslateText;
